import styled from 'styled-components';

const StyledContainer = styled.div`
	transition: opacity 0.3s ease;
	background-color: #111111;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

export { StyledContainer };
